import React from 'react'

export const ConversationIllustration = () => {
    return (
        <svg
            width="40"
            height="50"
            viewBox="0 0 81 102"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M36.5165 11.343C37.6388 11.343 38.7283 11.2822 39.7368 11.09C41.3025 10.7915 41.9179 12.7694 44.8536 13.6286C43.1795 12.2649 42.5206 10.3784 43.5768 9.8501C45.1485 9.0641 46.8924 7.67377 46.8924 5.75595C46.8924 2.67031 42.247 0.168945 36.5165 0.168945C30.7861 0.168945 26.1406 2.67026 26.1406 5.75595C26.1406 8.84159 30.7861 11.343 36.5165 11.343ZM41.3696 4.58557C41.786 4.58557 42.1237 4.92318 42.1237 5.33956C42.1237 5.75595 41.786 6.09356 41.3696 6.09356C40.9534 6.09356 40.6157 5.75595 40.6157 5.33956C40.6157 4.92318 40.9534 4.58557 41.3696 4.58557ZM38.1344 4.58557C38.5507 4.58557 38.8882 4.92318 38.8882 5.33956C38.8882 5.75595 38.5506 6.09356 38.1344 6.09356C37.7179 6.09356 37.3804 5.75595 37.3804 5.33956C37.3804 4.92318 37.7179 4.58557 38.1344 4.58557ZM34.8989 4.58557C35.3153 4.58557 35.6529 4.92318 35.6529 5.33956C35.6529 5.75595 35.3153 6.09356 34.8989 6.09356C34.4826 6.09356 34.1451 5.75595 34.1451 5.33956C34.145 4.92318 34.4826 4.58557 34.8989 4.58557ZM31.6635 4.58557C32.0798 4.58557 32.4175 4.92318 32.4175 5.33956C32.4175 5.75595 32.0798 6.09356 31.6635 6.09356C31.2472 6.09356 30.9095 5.75595 30.9095 5.33956C30.9095 4.92318 31.2472 4.58557 31.6635 4.58557Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M63.1966 8.67484H46.9496C46.2275 9.57323 45.2296 10.2881 44.2143 10.8118C44.2369 11.0084 44.3836 11.3183 44.4519 11.4414C44.5025 11.5325 44.5579 11.6222 44.6176 11.7103H62.9888C64.2131 11.7103 65.2147 12.7119 65.2147 13.9362V37.233C65.2147 38.4573 64.2131 39.4588 62.9888 39.4588C50.1277 39.4588 31.3721 39.4588 18.5111 39.4588C17.2869 39.4588 16.2852 38.4573 16.2852 37.233V13.9361C16.2852 12.7118 17.2869 11.7102 18.5111 11.7102H31.0525C30.3272 11.4875 29.6243 11.2134 28.9602 10.8825C27.8998 10.3539 26.8412 9.61922 26.0845 8.6748H18.3034C15.5239 8.6748 13.25 10.9489 13.25 13.7284V37.4405C13.25 40.2201 15.5239 42.4941 18.3034 42.4941H38.9745V46.2009H31.735C30.8122 46.2009 30.0639 46.9491 30.0639 47.872C30.0639 48.7948 30.8122 49.5432 31.735 49.5432H40.6457H49.765C50.6878 49.5432 51.4361 48.7948 51.4361 47.872C51.4361 46.9491 50.6878 46.2009 49.765 46.2009H42.3168V42.4941H63.1966C65.9761 42.4941 68.25 40.2201 68.25 37.4405V13.7284C68.25 10.9489 65.976 8.67484 63.1966 8.67484Z"
                fill="black"
            />
            <path
                d="M34.6368 19.4259C36.0412 19.4259 37.1798 18.2873 37.1798 16.8829C37.1798 15.4784 36.0412 14.3398 34.6368 14.3398C33.2323 14.3398 32.0938 15.4784 32.0938 16.8829C32.0938 18.2873 33.2323 19.4259 34.6368 19.4259Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.8973 21.8028C30.8973 21.9491 30.8929 22.451 30.8906 22.955H38.3711V21.8028C38.3711 21.0613 37.947 20.393 37.2615 19.9118C36.9096 19.6649 36.4883 19.4671 36.0201 19.3345C35.6108 19.5662 35.138 19.6987 34.6342 19.6987C34.1304 19.6987 33.6574 19.5662 33.2483 19.3345C32.7801 19.4671 32.3587 19.6649 32.0069 19.9118C31.3214 20.3931 30.8973 21.0613 30.8973 21.8028Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M52.0254 13.6284V24.6295H41.7026V13.6284H39.7927V24.6295H29.4702V13.6284H27.5602V24.6295H18.0391V26.5396H27.5602V37.5406H29.4702V26.5396H39.7927V37.5406H41.7026V26.5396H52.0254V37.5406H53.9353V26.5396H63.4561V24.6295H53.9353V13.6284H52.0254Z"
                fill="black"
            />
            <path
                d="M22.4023 19.4258C23.8068 19.4258 24.9453 18.2873 24.9453 16.8828C24.9453 15.4784 23.8068 14.3398 22.4023 14.3398C20.9979 14.3398 19.8594 15.4784 19.8594 16.8828C19.8594 18.2873 20.9979 19.4258 22.4023 19.4258Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.6709 21.8028C18.6709 21.9491 18.6664 22.451 18.6641 22.955H26.1446V21.8028C26.1446 21.0613 25.7206 20.393 25.035 19.9118C24.683 19.6649 24.2617 19.4671 23.7936 19.3345C23.3844 19.5662 22.9116 19.6987 22.4076 19.6987C21.9039 19.6987 21.431 19.5662 21.0217 19.3345C20.5537 19.4671 20.1323 19.6649 19.7803 19.9118C19.095 20.3931 18.6709 21.0613 18.6709 21.8028Z"
                fill="black"
            />
            <path
                d="M59.0977 19.426C60.5022 19.426 61.6408 18.2874 61.6408 16.8829C61.6408 15.4784 60.5022 14.3398 59.0977 14.3398C57.6933 14.3398 56.5547 15.4784 56.5547 16.8829C56.5547 18.2874 57.6933 19.426 59.0977 19.426Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M55.3582 21.8028C55.3582 21.9491 55.3538 22.451 55.3516 22.955H62.8319V21.8028C62.8319 21.0613 62.4079 20.393 61.7224 19.9118C61.3704 19.6649 60.9491 19.4671 60.4809 19.3345C60.0717 19.5662 59.599 19.6987 59.095 19.6987C58.5913 19.6987 58.1184 19.5662 57.7091 19.3345C57.2412 19.4671 56.8197 19.6649 56.4678 19.9118C55.7823 20.3931 55.3582 21.0613 55.3582 21.8028Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M49.4961 19.9118C49.1441 19.6649 48.7228 19.4671 48.2546 19.3345C47.8454 19.5662 47.3726 19.6987 46.8687 19.6987C46.3647 19.6987 45.892 19.5662 45.4828 19.3345C45.0146 19.4671 44.5933 19.6649 44.2413 19.9118C43.5559 20.393 43.1318 21.0613 43.1318 21.8028C43.1318 21.9491 43.1274 22.4511 43.125 22.955H50.6055V21.8028C50.6056 21.0613 50.1816 20.393 49.4961 19.9118Z"
                fill="black"
            />
            <path
                d="M46.8633 19.4259C48.2678 19.4259 49.4063 18.2873 49.4063 16.8829C49.4063 15.4784 48.2678 14.3398 46.8633 14.3398C45.4589 14.3398 44.3203 15.4784 44.3203 16.8829C44.3203 18.2873 45.4589 19.4259 46.8633 19.4259Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37.1798 30.7573C37.1798 29.353 36.0413 28.2144 34.6368 28.2144C33.2323 28.2144 32.0938 29.353 32.0938 30.7573C32.0938 32.1619 33.2323 33.3006 34.6368 33.3006C36.0413 33.3006 37.1798 32.1619 37.1798 30.7573Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.8973 35.6774C30.8973 35.8236 30.8929 36.3256 30.8906 36.8296H38.3711V35.6774C38.3711 34.9359 37.947 34.2676 37.2615 33.7863C36.9096 33.5394 36.4883 33.3417 36.0201 33.209C35.6108 33.4408 35.138 33.5732 34.6342 33.5732C34.1304 33.5732 33.6574 33.4408 33.2483 33.209C32.7801 33.3417 32.3587 33.5394 32.0069 33.7863C31.3214 34.2676 30.8973 34.9359 30.8973 35.6774Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.9453 30.7573C24.9453 29.353 23.8069 28.2144 22.4023 28.2144C20.998 28.2144 19.8594 29.353 19.8594 30.7573C19.8594 32.1619 20.998 33.3006 22.4023 33.3006C23.8069 33.3006 24.9453 32.1619 24.9453 30.7573Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.6709 35.6774C18.6709 35.8236 18.6664 36.3256 18.6641 36.8296H26.1446V35.6774C26.1446 34.9359 25.7206 34.2676 25.035 33.7863C24.683 33.5394 24.2617 33.3417 23.7936 33.209C23.3844 33.4408 22.9116 33.5732 22.4076 33.5732C21.9039 33.5732 21.431 33.4408 21.0217 33.209C20.5537 33.3417 20.1323 33.5394 19.7803 33.7863C19.095 34.2676 18.6709 34.9359 18.6709 35.6774Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M61.6408 30.7573C61.6408 29.353 60.5022 28.2144 59.0977 28.2144C57.6933 28.2144 56.5547 29.353 56.5547 30.7573C56.5547 32.1619 57.6933 33.3006 59.0977 33.3006C60.5022 33.3006 61.6408 32.1619 61.6408 30.7573Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M55.3582 35.6774C55.3582 35.8236 55.3538 36.3256 55.3516 36.8296H62.8319V35.6774C62.8319 34.9359 62.4079 34.2676 61.7224 33.7863C61.3704 33.5394 60.9491 33.3417 60.4809 33.209C60.0717 33.4408 59.599 33.5732 59.095 33.5732C58.5913 33.5732 58.1184 33.4408 57.7091 33.209C57.2412 33.3417 56.8197 33.5394 56.4678 33.7863C55.7823 34.2676 55.3582 34.9359 55.3582 35.6774Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M49.4063 30.7573C49.4063 29.353 48.2678 28.2144 46.8633 28.2144C45.4589 28.2144 44.3203 29.353 44.3203 30.7573C44.3203 32.1619 45.4589 33.3006 46.8633 33.3006C48.2678 33.3006 49.4063 32.1619 49.4063 30.7573Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M43.1318 35.6774C43.1318 35.8236 43.1274 36.3256 43.125 36.8296H50.6055V35.6774C50.6055 34.9359 50.1815 34.2676 49.496 33.7863C49.144 33.5394 48.7227 33.3417 48.2545 33.209C47.8453 33.4408 47.3726 33.5732 46.8686 33.5732C46.3647 33.5732 45.892 33.4408 45.4827 33.209C45.0145 33.3417 44.5933 33.5394 44.2412 33.7863C43.5559 34.2676 43.1318 34.9359 43.1318 35.6774Z"
                fill="black"
            />
            <rect
                x="0.75"
                y="65.543"
                width="47.8431"
                height="6"
                rx="3"
                fill="black"
            />
            <rect
                x="80.75"
                y="91.543"
                width="47.8431"
                height="6"
                rx="3"
                transform="rotate(-180 80.75 91.543)"
                fill="black"
            />
            <rect
                x="52.5156"
                y="65.1689"
                width="28.2353"
                height="6"
                rx="3"
                fill="black"
            />
            <rect
                x="28.9844"
                y="91.543"
                width="28.2353"
                height="6"
                rx="3"
                transform="rotate(-180 28.9844 91.543)"
                fill="black"
            />
            <rect
                x="41.5312"
                y="75.543"
                width="39.2157"
                height="6"
                rx="3"
                fill="black"
            />
            <rect
                x="28.9844"
                y="75.543"
                width="8.62745"
                height="6"
                rx="3"
                fill="black"
            />
            <rect
                x="28.9844"
                y="95.543"
                width="8.62745"
                height="6"
                rx="3"
                fill="black"
            />
            <rect
                x="0.75"
                y="75.543"
                width="25.098"
                height="6"
                rx="3"
                fill="black"
            />
            <rect
                x="0.75"
                y="95.543"
                width="25.098"
                height="6"
                rx="3"
                fill="black"
            />
        </svg>
    )
}
